import script from "./noData.vue?vue&type=script&setup=true&lang=js"
export * from "./noData.vue?vue&type=script&setup=true&lang=js"

import "./noData.vue?vue&type=style&index=0&id=9707b64c&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9707b64c"]])

export default __exports__